<template>
    <div class="table-row" :style="!content && !list ? 'align-items: center' : ''">
        <div class="title-area">
            <div class="img-box">
                <img v-if="src" :src="require(`@/assets/${src}`)" alt="" />
                <div v-else class="no-image"></div>
            </div>
        </div>
        <div class="content-area">
            <p class="title">{{ title || '' }}</p>
            <p v-if="content" v-html="content"></p>
            <ul v-if="list">
                <li v-for="(item, idx) in list" :key="idx" v-html="item"></li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {},
        content: {},
        list: {},
        src: {},
    },
};
</script>
<style lang="scss" scoped>
.table-row {
    padding: 70px 0;
    border-bottom: 1px solid var(--border-color1);
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .title-area {
        flex: 0 0 174px;
        padding-left: 55px;
        margin-right: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .img-box {
            width: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 25px;
        }
    }

    .no-image {
        width: 60px;
        height: 60px;
        border-radius: 4px;
        background: var(--gray1);
    }

    .content-area {
        flex: 1 1 auto;
        padding-right: 60px;

        p.title {
            flex: 1;
            font-family: 'Pretendard', sans-serif;
            font-weight: 700;
            font-size: 22px;
            letter-spacing: -0.025em;
            color: var(--black1);
            @media screen and (max-width: 768px) {
                font-size: 20px;
            }

            & + p {
                margin-top: 32px;
            }
        }

        p {
            font-family: 'Pretendard', sans-serif;
            font-size: 18px;
            color: var(--black2);
            letter-spacing: -0.025em;
            font-weight: 400;
            line-height: 1.6;
            word-break: keep-all;
            color: var(--black3);
            @media screen and (max-width: 768px) {
                font-size: 16px;
            }
        }

        ul {
            margin-top: 32px;
        }

        ul li {
            position: relative;
            list-style: none;
            letter-spacing: -0.025em;
            padding-left: 12px;
            color: var(--black3);
            font-weight: 400;
            font-family: 'Pretendard', sans-serif;
            font-size: 18px;
            word-break: keep-all;
            @media screen and (max-width: 768px) {
                font-size: 16px;
            }

            & + li {
                margin-top: 10px;
            }

            &::after {
                position: absolute;
                content: '';
                width: 4px;
                height: 4px;
                background: #ccc;
                top: calc(1ch - 2px);
                left: 0;
            }
        }
    }
}
</style>
